import { Component, OnInit, ViewEncapsulation, Input, ViewChild, ElementRef  } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { BreadCrumb } from './breadcrumb';
import { filter, distinctUntilChanged, map } from 'rxjs/operators';
import { TRANSLATE } from '../../shared/classes/translatable';
import { Bureau } from '../shared/classes/bureau';
import { AuthenticationService } from '../services/authentication.service';
import { StorageService } from '../../shared/services/storage.service';
import { InfrastructureService } from '../../infrastructure/shared/services/infrastructure.service';
import { Batiment } from '../../infrastructure/shared/classes/batiment';
import { EventService } from '../../shared/services/event.service';
import { IdentiteService } from '../../identite/shared/services/identite.service';
import { Role } from '../../identite/shared/classes/role';


@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class BreadcrumbComponent implements OnInit {

    @Input() bureaux: Bureau[];
    @Input() batiments: Batiment[];
    @Input() currentBureau: Bureau;
    @Input() currentBatiment: Batiment;
    @Input() maitres: Role[];
    @Input() currentMaitre: Role;

    selecteur: string;

    breadcrumbs$ = this.router.events
        .pipe(
            filter(event => event instanceof NavigationEnd),
            distinctUntilChanged(),
            map(event => this.buildBreadCrumb(this.activatedRoute.root))
        );

    constructor(
        private activatedRoute: ActivatedRoute,
        private storageService: StorageService,
        private eventService: EventService,
        private router: Router,
        private infraService: InfrastructureService,
        private authService: AuthenticationService,
        private identiteService: IdentiteService,
    ) {
        this.bureaux = [];
        this.maitres = [];
        this.batiments = [];
    }

    ngOnInit() {
        this.getConfiguration();
    }

    buildBreadCrumb(route: ActivatedRoute, url: string = '',
                breadcrumbs: Array<BreadCrumb> = []): Array<BreadCrumb> {
        // If no routeConfig is avalailable we are on the root path
        const label = route.routeConfig ? route.routeConfig.data[ 'breadcrumb' ] : TRANSLATE('Home');
        const path = route.routeConfig ? route.routeConfig.path : '';
        // In the routeConfig the complete path is not available,
        // so we rebuild it each time
        const nextUrl = route.routeConfig && route.routeConfig.data['noroute'] ? '' : `${url}${path}/`;
        const breadcrumb = {
            label: label,
            url: nextUrl
        };

        let newBreadcrumbs = [];
        if (label === '') {
            newBreadcrumbs = [ ...breadcrumbs ];
        } else {
            newBreadcrumbs = [ ...breadcrumbs, breadcrumb ];
        }

        // const newBreadcrumbs = [ ...breadcrumbs, breadcrumb ];
        if (route.firstChild) {
            // If we are not on our current path yet,
            // there will be more children to look after, to build our breadcumb
            return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
        }

        if (path !== '') {
            return newBreadcrumbs;
        } else {
            return breadcrumbs;
        }
    }


    changeBureau(event: any) {
        const bureauId = event.target.value;

        if (bureauId !== '0') {
            this.currentBureau = new Bureau(this.bureaux.find(b => b.id === bureauId));
        } else {
            this.currentBureau = new Bureau(this.currentBureau);
            this.currentBureau.id = bureauId;
        }

        this.authService.setBureau(this.currentBureau)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.resetMaitre();
                this.resetBatiment();
            }
        });
    }

    resetStorage() {
        this.storageService.navStorage.setReset(true);
    }

    changeMaitre(maitre: Role) {
        this.authService.setMaitre(maitre);
        this.resetBatiment();
    }

    resetMaitre() {
        this.authService.resetMaitre();
        this.currentMaitre = JSON.parse(localStorage.getItem('maitreOuvrage'));
        this.getMaitres();

    }

    changeBatiment(batiment: Batiment) {
        this.authService.setBatiment(batiment);
        this.getBatiments();
    }

    resetBatiment() {
        this.authService.resetBatiment();
        this.currentBatiment = JSON.parse(localStorage.getItem('batiment'));
        this.getBatiments();

    }
    getBatiments() {
        this.batiments = [];
        if(this.currentMaitre && this.currentMaitre.id && this.currentMaitre.id !== '0'){
            this.infraService.getBatimentsByMaitre(this.currentMaitre.id)
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.batiments = retour.data;
                }
                this.eventService.emitBatimentEvent(this.batiments);
                this.storageService.setBatiments(this.batiments);
            }); 
        }
    }

    getMaitres() {
        this.maitres = [];

        this.identiteService.getIdentiteFiltered('maitre_ouvrage', null, null, null, null, null, 'hydrate')
            .subscribe(retour => {
                if(retour.status === 200) {
                    this.maitres = retour.data;
                }
            
            this.eventService.emitMaitreEvent(this.maitres);
            this.storageService.setMaitres(this.maitres);
            });
    }

    getConfiguration() {
        const configuration = JSON.parse(localStorage.getItem('configuration'));
        this.selecteur = configuration.a17_selecteurs;
    }
}
